import Box from '@mui/material/Box';
import styled from '@emotion/styled';

export const GalleryItem = styled(Box)(({ fullscreen })=>({
  height: fullscreen ? 'inherit' : '30vh',
  position: 'relative',
  '@media(min-width: 991px)': {
    height: fullscreen ? 'inherit' : '50vh',
  },
  '@media(min-width: 1199px)':{
    height: fullscreen ? 'inherit' : '60vh',
  },
}));
export default GalleryItem;